
import { mapActions } from 'vuex';
// Models
import Location from '../models/location';

export default {
  name: 'SNoResult',
  props: {
    title: {
      type: String,
      required: true,
    },
    results: {
      type: Array,
      default: () => [],
    },
    center: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions({
      updateCurrentSearch: 'transferData/updateCurrentSearch',
    }),
    goToCity(result) {
      // Type 3 "city" by default
      result.type = 3;
      this.updateCurrentSearch(new Location(result));
      const admin = result.admin ? result.admin.alias : result.country.alias;
      const place = result.city.alias;
      this.$newRouter.replace({
        name: 'list-city',
        params: {
          admin, place,
        },
      });
    },
    getStyleDirection(location) {
      // Algorithm from https://www.movable-type.co.uk/scripts/latlong.html rhumbBearingTo()
      const radians = (n) => n * (Math.PI / 180);
      const degrees = (n) => n * (180 / Math.PI);
      const centerLat = radians(this.center.lat);
      const centerLong = radians(this.center.lon);
      const locationLat = radians(location.lat);
      const locationLong = radians(location.lon);
      let distanceLong = locationLong - centerLong;

      if (Math.abs(distanceLong) > Math.PI) {
        if (distanceLong > 0.0) {
          distanceLong = -(2.0 * Math.PI - distanceLong);
        } else {
          distanceLong = (2.0 * Math.PI + distanceLong);
        }
      }

      const distanceLat = Math.log(Math.tan(locationLat / 2.0 + Math.PI / 4.0) / Math.tan(centerLat / 2.0 + Math.PI / 4.0));
      const angle = (degrees(Math.atan2(distanceLong, distanceLat)) + 360) % 360;

      // + 90 because arrow_back icon point at -90 deg
      return `transform: rotate(${angle + 90}deg);`;
    },
  },
};
